const promotionCatalog = {
  WELCOME10: { code: "WELCOME10", label: "Welcome offer", percent: 10 },
  PANTRY15: { code: "PANTRY15", label: "Pantry offer", percent: 15 },
};

export const resolvePromotion = (value) => {
  const code = typeof value === "string" ? value : value?.code;
  return code ? promotionCatalog[String(code).trim().toUpperCase()] || null : null;
};

export default promotionCatalog;
